import { Environment, BindingError } from "@contember/binding";
const projectEnvironmentExtension = Environment.createExtension((slug) => {
  if (slug === void 0) {
    throw new BindingError("Environment does not contain project slug state.");
  }
  return {
    slug: slug ?? void 0
  };
});
export {
  projectEnvironmentExtension
};
//# sourceMappingURL=ProjectEnvironmentExtension.js.map
